/* eslint-disable react/no-array-index-key */
import { convertCentsToDollars } from '../../../../utilities/utils';

const warrantyItems = ({
  warranties,
}) => (
  <div className="warranty-items d-flex flex-column">
    <div className="warranty-items-body ff-graphik">
      <div className="warranty-items-header">
        <h3 className="warranty-items-heading ff-wallop c-purple-primary">Accident Protection</h3>
        <p className="c-light-midnight fs-14 fw-medium">Provided by Extend&#174;</p>
      </div>
      {warranties.map((product, index) => {
        const salePrice = convertCentsToDollars(product?.discountedPricePerQuantity?.discountedPrice?.value?.centAmount) * product.quantity || '';
        const totalPrice = convertCentsToDollars(product.totalPrice.centAmount);
        return (
          <div
            key={product.id}
            className="warranty-items-item"
          >
            <div className="d-flex align-items-start">
              <div className="d-flex flex-column">
                <span className="c-purple-primary fs-p3 fw-medium ff-graphik warranty-info-item m-b-8">
                  {product.name['en-US']}
                </span>
                <span className="c-light-midnight shipment-info-item fs-p3 m-b-8">
                  {product.variant.attributes.product}
                </span>
                <span className="c-light-midnight shipment-info-item fs-p3 m-b-8">
                  {product.variant.attributes.term}
                </span>
                <div className="c-light-midnight d-flex align-items-center fs-p3 fw-medium ff-graphik warranty-info-item">
                  {salePrice && (
                  <span className="td-strikethrough">
                    $
                    {salePrice}
                  </span>
                  )}
                  <span
                    className={`${
                      salePrice && 'm-l-8 c-aqua-dark'
                    }`}
                  >
                    $
                    {totalPrice}
                  </span>
                </div>
              </div>
            </div>
            {warranties.length > 1 && index !== warranties.length - 1 && (
              <div className="warranty-items-item-divider" />
            )}
          </div>
        );
      })}
    </div>
  </div>
);

export default warrantyItems;
